module.exports = __webpack_public_path__ + "static/img/church_01.ad75e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/church_01.png
// module id = AUE9
// module chunks = 0